<template>
    <div class="px-5">
        <div class="pb-4 qgreycard">
            <div class="quarolbl pb-2 pb-2">
                PROJECT TITLE
                <v-tooltip max-width="250" color="" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                    </template>
                    <span>The "Project Title" field specifies the title of your monitoring project. </span>
                </v-tooltip>
            </div>
            <v-text-field type="text" rounded filled v-model="project.title" hint="e.g. Optimization: KW-Research" persistent-hint></v-text-field>
        </div>

        <div class="pb-4 qgreycard">
            <div class="quarolbl pb-2">
                YOUR DOMAIN
                <v-tooltip max-width="250" color="" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                    </template>
                    <span>Select the focus domain you want to monitor.</span>
                </v-tooltip>
            </div>
            <v-text-field :disabled="disabled" class="mb-2" v-model="inputDomain" rounded filled hint="e.g. https://www.xxxlutz.de" persistent-hint></v-text-field>
        </div>
        <div class="pb-4 qgreycard">
            <div class="quarolbl pb-2">
                LOCATION
                <v-tooltip max-width="250" color="" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                    </template>
                    <span>The "Location" field specifies the geographical location of the search results that will be analyzed. </span>
                </v-tooltip>
            </div>
            <v-select
                :items="textMap"
                :disabled="disabled"
                rounded
                v-model="project.langloc"
                item-text="location_text"
                item-value="location_code"
                prepend-inner-icon="mdi-map-marker"
                return-object
                filled
                attach>
            </v-select>
        </div>
        <v-row no-gutters>
            <v-col cols="6">
                <div class="qgreycard mt-0">
                    <div class="quarolbl pb-1">
                        DEVICE
                        <v-tooltip max-width="250" color="" top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                            </template>
                            <span>The "Device" field specifies the type of device the rankings will be fetched for.</span>
                        </v-tooltip>
                    </div>
                    <v-chip-group class="py-0" color="primary" column show-arrows v-model="deviceFilter" mandatory next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left">
                        <v-chip v-for="(deviceType, i) in deviceTypes" :key="i" filter close-icon="mdi-close-circle-outline" filter-icon="mdi-check-circle">
                            <span style="text-transform: capitalize"> {{ deviceType }}</span>
                        </v-chip>
                    </v-chip-group>
                    <!-- <v-radio-group mandatory :disabled="disabled" class="mt-0" v-model="project.device_type" row>
                <v-radio label="Mobile (recommended)" value="mobile"></v-radio>
                <v-radio label="Desktop" value="desktop"></v-radio>
            </v-radio-group> -->
                </div>
            </v-col>
            <v-col cols="6">
                <div class="qgreycard mt-0">
                    <div class="quarolbl pb-1">
                        Update Interval
                        <v-tooltip max-width="250" color="" top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                            </template>
                            <span>The "Update Interval" specifies if the rankings of your project will be updated every day, once a week or once a month.</span>
                        </v-tooltip>
                    </div>
                    <v-chip-group class="py-0" color="primary" column show-arrows v-model="intervalFilter" return-object mandatory next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left">
                        <v-chip v-for="(interval, i) in intervalTexts" :key="i" filter close-icon="mdi-close-circle-outline" filter-icon="mdi-check-circle">
                            <span style="text-transform: capitalize"> {{ interval }}</span>
                        </v-chip>
                    </v-chip-group>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import axios from "axios"
    export default {
        props: {
            project: Object
        },
        data() {
            return {
                inputDomain: "",
                deviceFilter: [0],
                intervalFilter: [0],
                disabled: false,
                deviceTypes: ["mobile", "desktop", "tablet"],
                intervalTexts: ["daily", "weekly", "monthly"],
                intervalTypes: [1, 7, 30],
                textMap: [
                    { location_text: "Germany", language_code: "de", location_code: 2276 },
                    { location_text: "Switzerland (de)", language_code: "de", location_code: 2756 },
                    { location_text: "Austria (de)", language_code: "de", location_code: 2040 },
                    { location_text: "United Kingdom", language_code: "en", location_code: 2826 },
                    { location_text: "United States", language_code: "en", location_code: 2840 }
                ]
            }
        },

        methods: {
            async validateDomain() {
                const rawDomain = String(this.project?.domain || "")
                const hasAnyScheme = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//.test(rawDomain)
                const hasAllowedScheme = /^(https?|ftp|smtp):\/\//i.test(rawDomain)
                const hasScheme = hasAllowedScheme

                try {
                    if (hasAnyScheme && !hasAllowedScheme) {
                        console.log("Ungültige Domain: " + rawDomain)
                    } else {
                        const testUrl = hasScheme ? new URL(rawDomain) : null
                        const hostValue = hasScheme ? testUrl.host : rawDomain.split("/")[0]
                        const hostname = hasScheme ? testUrl.hostname : hostValue.split(":")[0]
                        const hostnamePattern = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9-]{2,63}$/i
                        const isValidHostname = hostnamePattern.test(hostname)

                        if (isValidHostname) {
                            console.log("Gültige Domain: " + rawDomain)
                            console.log(hostValue)
                            console.log(hostname)
                        } else {
                            console.log("Ungültige Domain: " + rawDomain)
                        }
                    }
                } catch (error) {
                    console.log("Ungültige Domain: " + rawDomain)
                }
            },
            getIntervalText(interval) {
                return this.intervalTexts[this.intervals.indexOf(interval)]
            }
        },
        watch: {
            inputDomain(val) {
                const rawDomain = String(val || "").trim()
                console.log(rawDomain)
                const hasAnyScheme = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//.test(rawDomain)
                const hasAllowedScheme = /^(https?|ftp|smtp):\/\//i.test(rawDomain)
                const hasScheme = hasAllowedScheme

                try {
                    if (hasAnyScheme && !hasAllowedScheme) {
                        console.log("Ungültige Domain: " + this.project.domain)
                    } else {
                        const testUrl = hasScheme ? new URL(rawDomain) : null
                        const hostValue = hasScheme ? testUrl.host : rawDomain.split("/")[0]
                        const hostname = hasScheme ? testUrl.hostname : hostValue.split(":")[0]
                        const hostnamePattern = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9-]{2,63}$/i
                        const isValidHostname = hostnamePattern.test(hostname)

                        if (isValidHostname) {
                            console.log("Gültige Domain: " + rawDomain)
                            console.log(hostValue)
                            console.log(hostname)
                            // klein geschrieben wie die API (readMonitoringDomain) und der Bearbeiten-Dialog (EditProjectDialog.vue)
                            this.project.domain = hostValue.toLowerCase()
                        } else {
                            console.log("Ungültige Domain: " + this.project.domain)
                        }
                    }
                } catch (error) {
                    console.log("Ungültige Domain: " + this.project.domain)
                }
            },
            deviceFilter(val) {
                this.project.device = this.deviceTypes[val]
            },
            intervalFilter(val) {
                this.project.interval = this.intervalTypes[val]
            }
        }
    }
</script>

<style></style>
